(function () {
  "use strict";

  /*
    SPARC CART CONFIGURED PRICE V1

    Purpose:
    Replace Shopify's visible base product price in the cart with the
    customer's configured unit price.

    Hulk option surcharges are already reflected in the cart subtotal,
    but the old Supply cart template still displays Shopify's base item
    price in the Price / Total columns.

    This script calculates:
      configured unit price =
        Shopify base unit price
        + all visible Hulk option surcharges in [ $xx.xx ] brackets

      configured line total =
        configured unit price * quantity

    It changes DISPLAY ONLY. It does not alter Shopify/Hulk cart math.
  */

  if (window.__SPARC_CART_CONFIGURED_PRICE_V1__) return;
  window.__SPARC_CART_CONFIGURED_PRICE_V1__ = true;

  if (
    String(window.location.pathname || "")
      .toLowerCase()
      .replace(/\/+$/, "") !== "/cart"
  ) {
    return;
  }

  var READY_CLASS =
    "sparc-cart-configured-prices-ready";

  var SURCHARGE_RE =
    /\[\s*\$\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)\s*\]/g;

  var MONEY_RE =
    /\$\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)/;

  var observer = null;
  var updateTimer = null;

  function numberFromMoney(text) {
    var match =
      String(text || "").match(
        MONEY_RE
      );

    if (!match) {
      return null;
    }

    var value =
      parseFloat(
        match[1].replace(/,/g, "")
      );

    return isFinite(value)
      ? value
      : null;
  }

  function optionSurchargeTotal(row) {
    var text =
      String(
        row.textContent || ""
      );

    var total = 0;
    var match;

    SURCHARGE_RE.lastIndex = 0;

    while (
      (match =
        SURCHARGE_RE.exec(text))
    ) {
      var value =
        parseFloat(
          match[1].replace(/,/g, "")
        );

      if (isFinite(value)) {
        total += value;
      }
    }

    return total;
  }

  function quantityForRow(row) {
    var input =
      row.querySelector(
        'input[name^="updates"],' +
        'input[name*="updates"],' +
        'input[type="number"][name*="quantity"],' +
        'input[type="number"].quantity,' +
        'input[type="number"]'
      );

    if (!input) {
      return 1;
    }

    var qty =
      parseInt(
        input.value,
        10
      );

    return (
      isFinite(qty) &&
      qty > 0
    )
      ? qty
      : 1;
  }

  function directCells(row) {
    return Array.prototype.slice.call(
      row.children || []
    ).filter(function (node) {
      return (
        node &&
        node.tagName === "TD"
      );
    });
  }

  function findPriceCells(row) {
    var price =
      row.querySelector(
        'td[data-label="Price" i],' +
        'td[data-label*="price" i],' +
        '[data-cart-item-price],' +
        '.cart__price,' +
        '.cart-item__price'
      );

    var total =
      row.querySelector(
        'td[data-label="Total" i],' +
        'td[data-label*="total" i],' +
        '[data-cart-item-line-price],' +
        '.cart__line-price,' +
        '.cart-item__total'
      );

    /*
      Supply-theme structural fallback:
      Product | Price | Quantity | Total
    */
    if (!price || !total) {
      var cells =
        directCells(row);

      if (cells.length >= 4) {
        var qtyIndex = -1;

        for (
          var i = 0;
          i < cells.length;
          i++
        ) {
          if (
            cells[i].querySelector(
              'input[name^="updates"],' +
              'input[name*="updates"],' +
              'input[type="number"]'
            )
          ) {
            qtyIndex = i;
            break;
          }
        }

        if (qtyIndex > 0) {
          price =
            price ||
            cells[qtyIndex - 1];

          total =
            total ||
            cells[qtyIndex + 1] ||
            null;
        }
      }
    }

    return {
      price: price,
      total: total
    };
  }

  function moneyTarget(cell) {
    if (!cell) return null;

    var candidates =
      Array.prototype.slice.call(
        cell.querySelectorAll(
          ".money," +
          ".h3," +
          ".h4," +
          "span," +
          "strong"
        )
      );

    var target =
      candidates.find(
        function (node) {
          return (
            numberFromMoney(
              node.textContent
            ) !== null
          );
        }
      );

    return target || cell;
  }

  function currencyCode() {
    try {
      if (
        window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active
      ) {
        return Shopify.currency.active;
      }
    } catch (e) {}

    return "USD";
  }

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat(
        "en-US",
        {
          style: "currency",
          currency: currencyCode(),
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(value);
    } catch (e) {
      return (
        "$" +
        Number(value)
          .toFixed(2)
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ","
          )
      );
    }
  }

  function candidateRows() {
    var selectors = [
      "form[action*='/cart'] tbody tr",
      "form[action*='/cart'] .cart__row",
      "form[action*='/cart'] [data-cart-item]",
      ".cart-table tbody tr",
      ".cart__row",
      "[data-cart-item]",
      ".cart-item"
    ];

    var nodes =
      Array.prototype.slice.call(
        document.querySelectorAll(
          selectors.join(",")
        )
      );

    return nodes.filter(
      function (node, index) {
        return (
          nodes.indexOf(node) === index
        );
      }
    );
  }

  function processRow(row) {
    if (!row) return false;

    var cells =
      findPriceCells(row);

    if (
      !cells.price ||
      !cells.total
    ) {
      return false;
    }

    var priceTarget =
      moneyTarget(
        cells.price
      );

    var totalTarget =
      moneyTarget(
        cells.total
      );

    if (
      !priceTarget ||
      !totalTarget
    ) {
      return false;
    }

    var baseUnit =
      parseFloat(
        row.getAttribute(
          "data-sparc-base-unit-price"
        )
      );

    if (!isFinite(baseUnit)) {
      baseUnit =
        numberFromMoney(
          priceTarget.textContent
        );

      if (
        baseUnit === null
      ) {
        return false;
      }

      row.setAttribute(
        "data-sparc-base-unit-price",
        String(baseUnit)
      );
    }

    var surcharge =
      optionSurchargeTotal(row);

    var qty =
      quantityForRow(row);

    var configuredUnit =
      baseUnit +
      surcharge;

    var configuredLine =
      configuredUnit *
      qty;

    var unitText =
      formatMoney(
        configuredUnit
      );

    var lineText =
      formatMoney(
        configuredLine
      );

    if (
      priceTarget.textContent.trim() !==
      unitText
    ) {
      priceTarget.textContent =
        unitText;
    }

    if (
      totalTarget.textContent.trim() !==
      lineText
    ) {
      totalTarget.textContent =
        lineText;
    }

    cells.price.setAttribute(
      "data-sparc-configured-price",
      "true"
    );

    cells.total.setAttribute(
      "data-sparc-configured-total",
      "true"
    );

    return true;
  }

  function updateAll() {
    var rows =
      candidateRows();

    var changed = 0;

    rows.forEach(
      function (row) {
        if (
          processRow(row)
        ) {
          changed += 1;
        }
      }
    );

    document.documentElement.classList.add(
      READY_CLASS
    );

    console.info(
      "[SPARC CART CONFIGURED PRICE V1] Updated.",
      {
        rows: rows.length,
        configuredRows: changed
      }
    );
  }

  function scheduleUpdate() {
    window.clearTimeout(
      updateTimer
    );

    updateTimer =
      window.setTimeout(
        updateAll,
        60
      );
  }

  function start() {
    updateAll();

    observer =
      new MutationObserver(
        function () {
          scheduleUpdate();
        }
      );

    observer.observe(
      document.body,
      {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          "value"
        ]
      }
    );

    document.addEventListener(
      "change",
      function (event) {
        if (
          event.target &&
          event.target.matches &&
          event.target.matches(
            'input[name^="updates"],' +
            'input[name*="updates"],' +
            'input[type="number"]'
          )
        ) {
          scheduleUpdate();
        }
      }
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
